// A line typed or a chip tapped while the session is connecting (started, agent
// not in the room yet) is queued and sent once the agent joins, rather than
// raced against the connection or turned into a second session. Before any
// session exists (start failed) the send itself starts one; after the agent is
// in, it just sends.
export function shouldQueueSend({
  sessionStarted,
  agentJoined,
}: {
  sessionStarted: boolean;
  agentJoined: boolean;
}): boolean {
  return sessionStarted && !agentJoined;
}

// The agent can be in the room well before it can take a message: its
// participant appears first, and its chat handler and session come up over the
// next second or two (a replacement agent after a drop or an idle end is the
// same). A line sent in that gap is dropped or fails. It is ready once it
// reports a live state (listening, thinking or speaking); until then a send
// waits in the queue.
export function isAgentReady({
  agentJoined,
  agentState,
}: {
  agentJoined: boolean;
  agentState: string | undefined;
}): boolean {
  return (
    agentJoined &&
    (agentState === "listening" || agentState === "thinking" || agentState === "speaking")
  );
}
